import { createContext } from 'react';

export const EnableDeviceContext = createContext();
export const EnableDeviceDispatchContext = createContext();
